/**
 * @generated SignedSource<<acf2ee162da7da216e573e2f4dd3d01b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AutoRecordRuleFilterOrganizer = "ANYONE" | "SELF";
export type AutoRecordRuleLevel = "GROUP" | "USER" | "WORKSPACE";
export type AutoRecordRuleType = "RECORD" | "RESTRICT";
export type FilterAttendeeType = "EXTERNAL_ONLY" | "INTERNAL_AND_EXTERNAL" | "INTERNAL_ONLY";
import { FragmentRefs } from "relay-runtime";
export type CreateAndEditModalRule$data = {
  readonly autoRecordRuleUsers: ReadonlyArray<{
    readonly includeAllReports: boolean;
    readonly user: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"CopilotSettingsUserFilter" | "RuleConfigurationStepUserPill" | "UserSelectionStepGetIncludesString">;
    };
  }>;
  readonly filterAttendeeType: FilterAttendeeType;
  readonly filterKeywordsContains: ReadonlyArray<string | null> | null;
  readonly filterKeywordsRestrict: ReadonlyArray<string | null> | null;
  readonly filterMaximumAttendees: number | null;
  readonly filterMinimumAttendees: number | null;
  readonly filterOrganizer: AutoRecordRuleFilterOrganizer;
  readonly id: string;
  readonly ruleLevel: AutoRecordRuleLevel;
  readonly ruleType: AutoRecordRuleType;
  readonly " $fragmentType": "CreateAndEditModalRule";
};
export type CreateAndEditModalRule$key = {
  readonly " $data"?: CreateAndEditModalRule$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateAndEditModalRule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateAndEditModalRule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ruleType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AutoRecordRuleUser",
      "kind": "LinkedField",
      "name": "autoRecordRuleUsers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includeAllReports",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "UserSelectionStepGetIncludesString"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CopilotSettingsUserFilter"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RuleConfigurationStepUserPill"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ruleLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterAttendeeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterMinimumAttendees",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterMaximumAttendees",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterOrganizer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterKeywordsContains",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterKeywordsRestrict",
      "storageKey": null
    }
  ],
  "type": "AutoRecordRule",
  "abstractKey": null
};
})();

(node as any).hash = "9e99b86f95e1ce4b0f8781dc41564d9a";

export default node;
